module.exports = {
  quantityOptions: [1, 2, 4, 8],
  deliveryPrices: [5.0, 5.0, 7.55, 0]
};
